var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlberca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "shscgs5v9a",
    width: 47,
    height: 47,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 48.166h47V2H2v46.166z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shscgs5v9a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M19.815 23.226h11.37v-7.218h-11.37v7.218zm5.68 7.277c-2.722 0-4.386.966-5.68 1.94v-6.185h11.37v6.19c-1.325-1.003-2.946-1.945-5.69-1.945zM3.515 33.535c2.216 0 3.245.824 4.549 1.866 1.482 1.186 3.162 2.531 6.442 2.531 3.279 0 5.032-1.403 6.44-2.53 1.303-1.043 2.333-1.867 4.547-1.867 2.217 0 3.247.824 4.55 1.867 1.483 1.185 3.165 2.53 6.445 2.53.51 0 1.006-.034 1.471-.1.829-.119 1.404-.888 1.286-1.716-.118-.829-.883-1.404-1.716-1.286-.323.047-.673.07-1.041.07-.998 0-1.75-.174-2.4-.452.082-.187.129-.392.129-.61V7.686c0-1.253 1.02-2.274 2.274-2.274s2.274 1.02 2.274 2.274c0 .837.68 1.517 1.516 1.517.838 0 1.516-.68 1.516-1.517 0-2.926-2.38-5.306-5.306-5.306s-5.306 2.38-5.306 5.306v5.291H19.814v-5.67c0-1.253 1.02-2.274 2.275-2.274 1.254 0 2.274 1.02 2.274 2.274 0 .837.68 1.517 1.516 1.517.838 0 1.516-.68 1.516-1.517C27.395 4.38 25.015 2 22.09 2s-5.307 2.38-5.307 5.306V33.46c0 .343.119.656.311.91-.69.328-1.493.53-2.586.53-2.216 0-3.246-.824-4.548-1.866-1.483-1.186-3.163-2.53-6.443-2.53-.837 0-1.516.678-1.516 1.515 0 .838.68 1.517 1.516 1.517zM47.484 40.737c-3.28 0-4.962 1.344-6.444 2.53-1.304 1.043-2.334 1.867-4.551 1.867s-3.247-.824-4.55-1.866c-1.483-1.187-3.165-2.53-6.445-2.53-3.279 0-5.032 1.403-6.44 2.53-1.303 1.042-2.332 1.866-4.547 1.866-.837 0-1.516.678-1.516 1.516 0 .837.679 1.516 1.516 1.516 3.279 0 5.032-1.403 6.44-2.53 1.303-1.043 2.333-1.866 4.547-1.866 2.217 0 3.247.823 4.55 1.866 1.483 1.185 3.165 2.53 6.445 2.53 3.28 0 4.962-1.344 6.444-2.53 1.304-1.043 2.334-1.866 4.55-1.866.838 0 1.517-.68 1.517-1.517 0-.837-.68-1.516-1.516-1.516M10.668 43.824c-.24-.181-.475-.368-.71-.555-1.482-1.187-3.162-2.532-6.442-2.532-.838 0-1.516.679-1.516 1.516s.678 1.517 1.516 1.517c2.216 0 3.245.823 4.549 1.866.258.207.517.413.784.613.272.205.591.304.908.304.461 0 .917-.21 1.214-.606.502-.67.368-1.62-.303-2.123",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "rgwjy2ulab",
    width: 7,
    height: 5,
    x: 42,
    y: 30,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M42.388 30.503H49v3.88h-6.612v-3.88z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#rgwjy2ulab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M43.906 34.383c.244 0 .492-.059.721-.184.836-.453 1.743-.664 2.857-.664.837 0 1.516-.679 1.516-1.516 0-.838-.68-1.516-1.516-1.516-1.617 0-3.024.337-4.303 1.032-.736.4-1.009 1.32-.61 2.055.276.506.797.793 1.335.793",
    clipRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlberca);
export default __webpack_public_path__ + "static/media/alberca.9e863821542e67fdb3f6bfd909ec1ef4.svg";
export { ForwardRef as ReactComponent };